export const documentType = {
  EXISTENCE_CERTIFICATE: 'Certificado de Existencia',
  COMPANY_STATUTES: 'Estatutos de la Empresa',
  PROJECT_DESCRIPTION: 'Informe comercial de financiación',
  FINANCIAL_STATEMENTS: 'Estados Financieros',
  TAX_INSPECTION: 'Inspección de impuestos',
  ASSEMBLY_MINUTES: 'Acta de asamblea',
  VALUE_STUDY: 'Estudio de valorización',
};
